export default {
    parse(value, data) {
        let res = value;
        Object.entries(data || {}).forEach(entry => {
            let [key, v] = entry;
            res = res.replaceAll('{' + key + '}', v);
        });

        return res.replaceAll("\n", '<br>');
    }
}


// WEBPACK FOOTER //
// ./src/services/parser/ValueParser.js